import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'iv-live-confirmation-popup-content',
  templateUrl: './confirmation-popup-content.component.html',
  styleUrls: ['./confirmation-popup-content.component.css']
})
export class ConfirmationPopupContentComponent {

  @Input() message: string;
  @Input() popupSwitchName: string;
  @Input() confirmButtonText: string;
  @Input() confirmButtonStatisticName: string;
  @Input() cancelButtonStatisticName: string;

  @Output() confirmPopup: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closePopup: EventEmitter<string> = new EventEmitter<string>();

  confirm() {
    this.confirmPopup.emit(true);
  }

  close() {
    this.closePopup.emit(this.popupSwitchName);
  }
}
